import * as React from "react";
export const Arrow = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__arrow-wrap` },
    React.createElement("span", { className: `rj-ev-list__${props.componentPrefix}__arrow` }));
//# sourceMappingURL=Arrow.js.map